import React from 'react';
import TabsPage from './pages/Tabs';
import './styles/global.css';
import { useTipPopup } from './hooks/useTipPopup';
import TipPopup from './components/TipPopup';
import Footer from './components/Footer';

function App() {
  const { showPopup, closePopup, markAIUsed } = useTipPopup();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        <TabsPage markAIUsed={markAIUsed} />
      </div>
      <Footer />
      {showPopup && <TipPopup onClose={closePopup} />}
    </div>
  );
}

export default App; 